export default class FlighChangeInput {
  departureAirports: string;
  arrivalAirports: string;
  flightDateStarts: string;
  flightDateEnds: string;
  departureDateStarts: string;
  departureDateEnds: string;
  fromAirportIds:string;
  toAirportIds:string;
  flightNo: string;
  isActive: boolean;
}
